import { Link } from 'react-router-dom';
import { getProductPath } from '../productUrls';
import './CategoryCard.css';

function PromotionProductCard({ promotion }) {
  const original = promotion.originalPrice != null ? Number(promotion.originalPrice) : null;
  const price = Number(promotion.promotionPrice);
  const discount = original > price && original > 0
    ? Math.min(99, Math.round((1 - price / original) * 100))
    : 0;
  const to = !promotion.isStandalone && promotion.productCode
    ? getProductPath(promotion.productCode)
    : `/promotion/${promotion.id}`;

  return (
    <div className="category-card">
      <Link to={to} className="category-card-link">
        <div className="category-card-image-container">
          <img
            src={promotion.imageUrl || undefined}
            alt={promotion.productName}
            className="category-card-image"
          />
          <div className="category-card-promo-badge">
            {discount > 0 ? `-${discount}% OFF` : 'Promotion'}
          </div>
          <div className="category-card-overlay">
            <h3 className="category-card-title">{promotion.productName}</h3>
            {promotion.variantLabel && (
              <p className="search-results-promotion-variant">{promotion.variantLabel}</p>
            )}
            <div className="category-card-promo-price">
              {original > price && (
                <span className="category-card-original-price">RM {original.toFixed(2)}</span>
              )}
              <span className="category-card-sale-price">RM {price.toFixed(2)}</span>
            </div>
          </div>
        </div>
      </Link>
    </div>
  );
}

export default PromotionProductCard;
